// English (en-en) landing-page messages.
// To add a language: copy this file, translate the values, and register it in
// src/i18n/index.js with its locale code (e.g. 'fr-fr').
export default {
  nav: {
    features: 'Features',
    howItWorks: 'How it works',
    pricing: 'Pricing',
    login: 'Log in',
    startFree: 'Start free'
  },
  hero: {
    badge: 'Monitoring',
    statusLine: 'Email + SMS sent · incident started 14:07',
    titleTop: 'Your website has',
    titleAccent: 'a heartbeat.',
    subtitle: 'Know the minute your site goes down — before your customers notice. Monitoring every minute, alerts instantly.',
    ctaPrimary: 'Subscribe →',
    ctaSecondary: 'Log in to dashboard',
    scroll: 'Scroll'
  },
  features: {
    kicker: 'What you get',
    titleTop: 'Everything you need.',
    titleAccent: "Nothing you don't.",
    subtitle: 'Simple, focused monitoring for business owners who just want to know their site is up.',
    items: [
      { title: 'Every-minute checks', body: 'Pinged every 60 seconds. Downtime detected in under a minute.' },
      { title: 'Email & SMS alerts*', body: 'The moment something goes wrong you get an alert — no app to babysit, no dashboard to watch. *sms feature in development' },
      { title: 'Dashboard', body: 'Your personal dashboard: uptime %, response times, incident history.' },
      { title: 'Subdomains included', body: 'Monitor your main domain plus up to 25 subdomains — shop, blog, api — all under one plan.' }
    ]
  },
  how: {
    kicker: 'How it works',
    title: 'Up in three minutes flat.',
    subtitle: "No installation, no code, no learning curve. Add your URL and you're covered.",
    steps: [
      { title: 'Add your website', body: 'Enter your domain and any subdomains you want watched. Takes 30 seconds.' },
      { title: 'Set your alerts', body: 'Choose where to be notified — email, SMS, or both. Add multiple contacts.' },
      { title: 'We watch. You relax.', body: 'Custus checks every minute. If something goes wrong, you hear about it immediately.' }
    ]
  },
  pricing: {
    kicker: 'Pricing',
    title: 'Simple plans. Clear pricing.',
    subtitle: 'Pick the number of sites you need. No hidden add-ons, cancel anytime.',
    note: '*SMS feaure in developement.',
    perMonth: 'per month'
  },
  demo: {
    title: 'Request a demo',
    subtitle: "Tell us about your site and we'll show you Custus in action.",
    name: 'Your name',
    email: 'Email',
    website: 'Website to monitor',
    submit: 'Request demo',
    sending: 'Sending…',
    successTitle: 'Thanks!',
    successBody: "We'll be in touch shortly."
  },
  footer: {
    tagline: 'Website monitoring that never sleeps.',
    privacy: 'Privacy',
    termsAndConditions: "Terms and Conditions",
    privacyPolicy: "Privacy Policy",
    contact: 'Contact'
  }
}
